<template>
    <div>
        <div class="video-popup" :style="overlayBgStyle">
            
            <div class="video-popup__overlay"></div>
            <div class="video-popup__content">
                <div class="close-button">
                <q-btn icon="close" flat round dense @click="$emit('closeVideo')" />
                <ReturnHomeButton @click="$emit('closeAllDialogs')" />

            </div>
                <div v-for="(video, index) in videos" :key="index" class="video-popup__video">
                    <video :src="video" controls></video>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import axios from 'axios';
import { ref, onMounted } from 'vue';
import ReturnHomeButton from './ReturnHomeButton.vue';
import { useOverlayBg } from '../composables/useOverlayBg';

export default {
    name: 'VideoPopup',
    components: { ReturnHomeButton },
    props: ['blockVideoDatas'],
    setup(props) {
        const videos = ref([]);

        const start = () => {
            fetchVideos();
        }

        const fetchVideos = async () => {
            try {
                console.log(props.blockVideoDatas)
                if (props.blockVideoDatas) {
                    for (let i = 0; i < props.blockVideoDatas.associatedResources.length; i++) {
                        const url = `${process.env.VUE_APP_BASEURL}/s3Resource/${props.blockVideoDatas.associatedResources[i].name}`;
                        const response = await axios.get(url);
                        videos.value.push(response.data);
                    }
                }
            } catch (error) {
                console.log(error)

            }
        }

        onMounted(start);
        const { overlayBgStyle } = useOverlayBg();

        return {
            overlayBgStyle,
            videos,
        };
    },
};
</script>
  
<style scoped>
.video-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.video-popup__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(217, 217, 217, 0.5);
}

.video-popup__content {
    position: relative;
    max-width: 90%;
    max-height: 90%;
    overflow: auto;
}

.video-popup__close {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 24px;
    color: #fff;
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.video-popup__video {
    margin-bottom: 20px;
    position: relative;
    height: 80vh;
    /* 80% de la hauteur de l'écran */
}

.video-popup__video video {
    height: 100%;
    object-fit: contain;
}
</style>
  